var _alertClassicTheme;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { PackageNamespace } from '@tablekit/package-namespace';
import { COLORS } from '@tablekit/theme';
import { Appearance } from './utils.js';
var alertThemeNamespace = PackageNamespace.Alert;
var alertClassicTheme = (_alertClassicTheme = {}, _defineProperty(_alertClassicTheme, Appearance.Primary, {
  iconColor: function iconColor(_ref) {
    var theme = _ref.theme;
    return theme.colors.iconFill;
  },
  fillColor: function fillColor(_ref2) {
    var theme = _ref2.theme;
    return theme.colors.text;
  },
  borderColor: function borderColor(_ref3) {
    var theme = _ref3.theme;
    return theme.colors.text;
  }
}), _defineProperty(_alertClassicTheme, Appearance.Success, {
  iconColor: function iconColor(_ref4) {
    var theme = _ref4.theme;
    return theme.colors.success;
  },
  fillColor: function fillColor(_ref5) {
    var theme = _ref5.theme;
    return theme.colors.success;
  },
  borderColor: function borderColor(_ref6) {
    var theme = _ref6.theme;
    return theme.colors.success;
  }
}), _defineProperty(_alertClassicTheme, Appearance.Warning, {
  iconColor: function iconColor(_ref7) {
    var theme = _ref7.theme;
    return theme.colors.warning;
  },
  fillColor: function fillColor(_ref8) {
    var theme = _ref8.theme;
    return theme.colors.warning;
  },
  borderColor: function borderColor(_ref9) {
    var theme = _ref9.theme;
    return theme.colors.warning;
  }
}), _defineProperty(_alertClassicTheme, Appearance.Danger, {
  iconColor: function iconColor(_ref10) {
    var theme = _ref10.theme;
    return theme.colors.danger;
  },
  fillColor: function fillColor(_ref11) {
    var theme = _ref11.theme;
    return theme.colors.danger;
  },
  borderColor: function borderColor(_ref12) {
    var theme = _ref12.theme;
    return theme.colors.danger;
  }
}), _defineProperty(_alertClassicTheme, "backgroundColor", function backgroundColor(_ref13) {
  var theme = _ref13.theme;
  return theme.colors.surface;
}), _defineProperty(_alertClassicTheme, "boxShadowColor", COLORS.GRAY_TRANSLUCENT.L1), _defineProperty(_alertClassicTheme, "closeButton", {
  color: function color(_ref14) {
    var theme = _ref14.theme;
    return theme.colors.iconFill;
  }
}), _defineProperty(_alertClassicTheme, "textColor", function textColor(_ref15) {
  var theme = _ref15.theme;
  return theme.colors.text;
}), _alertClassicTheme);
var alertDarkTheme = alertClassicTheme;
export { alertClassicTheme, alertDarkTheme, alertThemeNamespace };
